import { HttpErrorResponse } from '@angular/common/http';

import type { AutoDeleteConfig, GdprAutoConsentCounter } from '@recruitee/gdpr-types';
import { createSingleEntityStore, ngrxEvent, pipeState } from '@recruitee/ngrx';

const { actions, namespace, reducer, selectors } =
  createSingleEntityStore<GdprAutoConsentCounter>()('GdprAutoDelete', {
    customActions: adapter => ({
      loadCounter: (state, payload: AutoDeleteConfig) => adapter.markAsPending(state),
      loadCounterSuccess: (state, payload: GdprAutoConsentCounter) =>
        pipeState(
          state,
          next => adapter.save(next, payload),
          next => adapter.markAsLoaded(next),
        ),
      loadCounterFailed: (state, payload: { error: HttpErrorResponse }) =>
        adapter.setError(state, payload.error),

      schedule: ngrxEvent<void>(),
      scheduleSuccess: ngrxEvent<{ uuid: string }>(),
      scheduleFailed: ngrxEvent<{ error: HttpErrorResponse }>(),
    }),
  });

const GdprAutoDeleteActions = <
  Pick<
    typeof actions,
    | 'loadCounter'
    | 'loadCounterSuccess'
    | 'loadCounterFailed'
    | 'schedule'
    | 'scheduleSuccess'
    | 'scheduleFailed'
  >
>actions;

export {
  GdprAutoDeleteActions,
  selectors as GdprAutoDeleteSelectors,
  namespace as GdprAutoDeleteNamespace,
  reducer as GdprAutoDeleteReducer,
};
